<div *ngIf="showOptions" class="option-container">
  <div *ngIf="!options?.length" class="place-holder"></div>
  <div *ngIf="options?.length>1 && !isMobile" class="options">
    <div *ngFor="let option of options">
      <button *ngIf="option" class="option-tab" type="button" (click)="setOptionRoute(option)" [ngClass]="{'is-active': activeButton==option.route}" [disabled]="optionsDisble || vars.isOrderLoading" mat-stroked-button>
        <span><i [ngClass]="option?.icon"></i></span> <span class="option-name">{{option?.name}}</span>
      </button>
    </div>
  </div>

  <div class="routes" *ngIf="!isMobile">
    <ng-template *ngIf="pCurrency!=='INR'" [ngTemplateOutlet]="stripeLink" />
    <app-netbanking [option]="paymentOptions?.options?.NB" [topBank]="paymentOptions?.options?.TOPNB" [hidden]="!(activeButton=='nb')"
      [cartDetails]="cartDetails" (dataEmit)="submitOrder($event)" [isOrderLoading]="isOrderLoading">
    </app-netbanking>
    <app-cards [cartDetails]="cartDetails" [option]="paymentOptions?.options?.CARD" [hidden]="!(activeButton=='c')" (dataEmit)="submitOrder($event)" [isOrderLoading]="isOrderLoading" [currency]="pCurrency" [showZip]="pCurrency !=='INR'?true:false">
    </app-cards>
    <app-paytm [option]="paymentOptions?.options?.PAYTM" [hidden]="!(activeButton=='p')" [cartDetails]="cartDetails" (dataEmit)="submitOrder($event)" [qrCodeUrl]="qrCodes?.paytm" [isOrderLoading]="isOrderLoading">
    </app-paytm>
    <app-wallets [option]="paymentOptions?.options?.WALLET" [hidden]="!(activeButton=='w')" [cartDetails]="cartDetails"
                (dataEmit)="submitOrder($event)" [isOrderLoading]="isOrderLoading" [topWallets]="paymentOptions?.options?.TOPWALLET">
    </app-wallets>
    <app-upi *ngIf="paymentOptions?.options" [option]="paymentOptions?.options" [cartDetails]="cartDetails" [isOrderLoading]="isOrderLoading" [qrURL]="qrCodes?.upi" [campaignId]="campaignId" [origin]="origin" [customTag]="customTag" [hidden]="!(activeButton=='u')" (dataEmit)="submitOrder($event)" (disableOptions)="disableOptions($event)" (cardDetailsEmit)="cartDetails=$event"></app-upi>
  </div>

  <!--for Mobile-->
  <div *ngIf="isMobile" class="options">
    <ng-template *ngIf="pCurrency!=='INR'" [ngTemplateOutlet]="stripeLink" />
    <app-cards [option]="paymentOptions?.options?.CARD" [hidden]="!(optionRoute.op=='c')" (dataEmit)="submitOrder($event)" [isOrderLoading]="isOrderLoading" [currency]="pCurrency" [showZip]="pCurrency !=='INR'?true:false">
    </app-cards>
    <app-paytm [option]="paymentOptions?.options?.PAYTM" [hidden]="!(optionRoute.op=='p')" [cartDetails]="cartDetails" (dataEmit)="submitOrder($event)" [isOrderLoading]="isOrderLoading">
    </app-paytm>
    <app-upi *ngIf="paymentOptions?.options" [option]="paymentOptions?.options" [hidden]="!(optionRoute.op=='u')" [cartDetails]="cartDetails" [isOrderLoading]="isOrderLoading" [qrURL]="qrCodes?.upi" [campaignId]="campaignId" [origin]="origin" [customTag]="customTag" (dataEmit)="submitOrder($event)" (disableOptions)="disableOptions($event)"></app-upi>
  </div>

  <div *ngIf="isMobile && !optionRoute.op" [ngClass]="{'prevent-click': vars.isOrderLoading}">

    <!-- All UPI options -->
    <div *ngIf="paymentOptions?.options?.UPI" class="cards">
      <div class="heading" [ngClass]="{'mt-0': vars.askTipOnPayOpt}">
        <h2>UPI</h2>
        <span><a (click)="goToInnerRoute('u', 'UPI')">View All UPI</a></span>
      </div>
      <div class="card-section UPI" [ngClass]="{'prevent-click blurBack': vars.isOrderLoading}" (click)="goToInnerRoute('u', 'UPI')" matRipple>
        <img loading="lazy" data-src="/assets/images/payment/upi-icons-1.png" alt="UPI icons" />
        <em class="material-icons">arrow_forward_ios</em>
      </div>
    </div>

    <div class="cards">
      <div class="heading" [ngClass]="{'mt-0': vars.askTipOnPayOpt && !paymentOptions?.options?.UPI}">
        <h2>DEBIT / CREDIT CARD</h2>
      </div>
      <div class="card-section" [ngClass]="{'prevent-click blurBack': vars.isOrderLoading}" (click)="goToInnerRoute('c', 'Debit/Credit')" matRipple>
        <img loading="lazy" data-src="/assets/images/story/Payment-Methods-icos.png" alt="Payment methods icons" />
        <i class="material-icons">arrow_forward_ios</i>
      </div>
    </div>
    <!-- All banks -->
    <div *ngIf="paymentOptions?.options?.TOPNB" class="cards">
      <div class="heading">
        <h2>Netbanking</h2>
        <span>
          <a (click)="openSelectMenu(allBanks, 'Net Banking')">View All Banks</a>
        </span>
      </div>
      <div class="card-section text-center" [ngClass]="{'prevent-click blurBack': vars.isOrderLoading}">
        <div *ngFor="let key of getObjectKeys(paymentOptions?.options?.TOPNB)" (click)="submitOrderMobile('NB', key)" class="all-bank submit-payment">
          <div [class]="key" [ngClass]="{'loader-key': isOrderLoading && submitOrderData?.mode_value === key}" matRipple data-bg="/assets/images/payment/top-netbanking.png">
            <div *ngIf="isOrderLoading && submitOrderData?.mode_value === key" class="dots-loader"><span></span></div>
          </div>
          <span class="b-name">{{paymentOptions?.options?.TOPNB[key]}}</span>
        </div>
      </div>
    </div>

    <!-- All wallets -->
    <div *ngIf="paymentOptions?.options?.TOPWALLET" class="cards wallets-container">
      <div class="heading">
        <h2>Wallets</h2>
        <span><a (click)="openSelectMenu(allWallet, 'Wallets')">View All Wallets</a></span>
      </div>
      <div class="card-section text-center" [ngClass]="{'prevent-click blurBack': vars.isOrderLoading}">
        <div *ngFor="let key of getObjectKeys(paymentOptions?.options?.TOPWALLET, 'wallet')" (click)="submitOrderMobile('WALLET', key)" class="all-bank submit-payment">
          <div [class]="key" [ngClass]="{'loader-key': isOrderLoading && submitOrderData?.mode_value === key}" matRipple>
            <div *ngIf="isOrderLoading && submitOrderData?.mode_value === key" class="dots-loader"><span></span></div>
          </div>
          <span class="b-name">{{paymentOptions?.options?.TOPWALLET[key]}}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<app-g-captcha (dataEmit)="gotCaptchaResponse($event)" />

<!-- options for listing bank -->
<ng-template #allBanks>
  <div class="list-dilaog">
    <div class="close">
      <button type="button" [ngClass]="{'visible-hide': vars.isOrderLoading}" (click)="location.back()" mat-icon-button><mat-icon>arrow_back</mat-icon> BACK</button>
    </div>
    <app-input class="search-input" inputType="text" [control]="searchText" [group]="searchForm" placeHolder="Search"
              (OnChange)="search($event)">
    </app-input>
    <mat-list>
      <div class="list-container bankDropdownList" *ngFor="let key of getObjectKeys(paymentOptions?.options?.NB)" mat-list-item>
        <button class="list-btn submit-payment" type="button" [disabled]="isOrderLoading" (click)="submitOrderMobile('NB', key)" mat-button>
          <span *ngIf="!(isOrderLoading && submitOrderData?.mode_value === key)">{{paymentOptions?.options?.NB[key]}} <mat-icon class="lits-icon" >keyboard_arrow_right</mat-icon></span>
          <div *ngIf="isOrderLoading && submitOrderData?.mode_value === key" class="dots-loader"><span></span></div>
        </button>
      </div>
    </mat-list>
  </div>
</ng-template>

<!-- options for listing bank -->
<ng-template #allWallet>
  <div class="list-dilaog">
    <div class="close">
      <button type="button" [ngClass]="{'visible-hide': vars.isOrderLoading}" (click)="location.back()" mat-icon-button><mat-icon>arrow_back</mat-icon> BACK</button>
    </div>
    <mat-list>
      <div class="list-container" *ngFor="let key of getObjectKeys(paymentOptions?.options?.WALLET, 'wallet')" mat-list-item>
        <button class="list-btn submit-payment" type="button" (click)="submitOrderMobile('WALLET', key)" mat-button>
          <span *ngIf="!(isOrderLoading && submitOrderData?.mode_value === key)">{{paymentOptions?.options?.WALLET[key]}} <mat-icon class="lits-icon" >keyboard_arrow_right</mat-icon></span>
          <div *ngIf="isOrderLoading && submitOrderData?.mode_value === key" class="dots-loader"><span></span></div>
        </button>
      </div>
    </mat-list>
  </div>
</ng-template>

<ng-template #stripeLink>
  <div *ngIf="isMobile && showStripeLink" class="sp-line"></div>
  <div *ngIf="payConfig?.optionsResponse" [hidden]="!showStripeLink" class="stripeLinkPay" [ngClass]="{'oneTapEnable': showOneTapPay}">
    <div class="actBtn">
      <app-stripe-express
        [amount]="cartDetails?.donated_amount||100"
        [currency]="cartDetails?.currency||'usd'"
        (availablePaymentMethods)="onStripeExpressReady($event)"
        (onCheckoutClick)="onStripeCheckoutClick($event)"
      />
    </div>
    <div class="orPay">
      <div class="line"></div>
      <div class="text">or pay with card</div>
      <div class="line"></div>
    </div>
  </div>
</ng-template>